// extracted by mini-css-extract-plugin
export default {"root":"NzPX8Z","bg":"lBcHAJ","i":"cEVeFE","b":"OYTBrq","l":"gwTnEh","r":"el8JM2"};